// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2bjOj","footer":"ModalFilter_footer__1z1F0"};